export default __webpack_public_path__ + "static/media/boxit.9946d168.png";